import { Component } from '@angular/core';
import { WorkflowBaseDroppedField } from '../base-dropped-field.component';

@Component({
  selector: 'app-workflow-droppable-inline-signature-field',
  templateUrl: './inline-signature.component.html',
  styleUrls: ['../../droppable-field.component.scss']
})
export class WorkflowDroppableInlineSignatureFieldComponent extends WorkflowBaseDroppedField {}
